import config from '../../../config'
import { authHeader, customFetch, handleResponse, commonRequestOptions } from '../../../helpers'
import { appName } from '../appConfig'

const base = `${appName}/story`

export const storyService = {
  getAll,
  getBySlug,
  getByUuid,
  getUsers,
  create,
  update,
  generate,
  remove,
  previewDraft,
}

function getAll(signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/all`, opts, signal).then(handleResponse)
}

function getUsers(signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/users`, opts, signal).then(handleResponse)
}

function getBySlug(slug, signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/by-slug/${slug}`, opts, signal).then(handleResponse)
}

function getByUuid(uuid, signal) {
  const opts = { method: 'GET', headers: authHeader(), ...commonRequestOptions() }
  return customFetch(`${config.api.url}/${base}/${uuid}`, opts, signal).then(handleResponse)
}

function create(payload, signal) {
  const opts = {
    method:  'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}`, opts, signal).then(handleResponse)
}

function update(uuid, payload, signal) {
  const opts = {
    method:  'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${uuid}`, opts, signal).then(handleResponse)
}

function generate(uuid, signal) {
  const opts = {
    method:  'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify({}),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${uuid}/generate`, opts, signal).then(handleResponse)
}

function remove(uuid, signal) {
  const opts = {
    method:  'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify({}),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/${uuid}`, opts, signal).then(handleResponse)
}

function previewDraft(payload, signal) {
  const opts = {
    method:  'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body:    JSON.stringify(payload),
    ...commonRequestOptions(),
  }
  return customFetch(`${config.api.url}/${base}/preview-draft`, opts, signal).then(handleResponse)
}
